import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-relative tw-inline-block tw-text-left" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-1.5" }
const _hoisted_3 = {
  key: 0,
  class: "tw-absolute tw-top-[-1px] tw-right-[-1px] tw-flex tw-h-2.5 tw-w-2.5"
}
const _hoisted_4 = {
  key: 0,
  class: "tw-absolute tw-left-0 tw-mt-2 tw-z-50 tw-w-80 tw-bg-white tw-border tw-border-slate-200 tw-rounded-2xl tw-shadow-xl tw-p-4"
}
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-3" }
const _hoisted_6 = { class: "tw-text-xs tw-text-slate-400 tw-w-12 tw-shrink-0" }
const _hoisted_7 = ["onUpdate:modelValue"]
const _hoisted_8 = ["value", "disabled"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "tw-flex tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen)),
        class: _normalizeClass(["tw-relative tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-backdrop-blur tw-border tw-rounded-xl tw-shadow-sm tw-transition-all tw-text-sm tw-font-medium", _ctx.isActive 
          ? 'tw-bg-slate-900 tw-border-slate-900 tw-text-white hover:tw-bg-slate-800' 
          : ('tw-border-slate-200 tw-text-slate-400 tw-opacity-80 ' + (_ctx.isOpen ? ' tw-bg-slate-400 tw-text-white' : ' tw-bg-white/60 hover:tw-text-slate-600 hover:tw-bg-white'))])
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: "filter",
          class: _normalizeClass(_ctx.isActive ? 'tw-text-white/80' : (_ctx.isOpen ? ' tw-text-white' : 'tw-text-slate-400'))
        }, null, 8, ["class"]),
        _cache[6] || (_cache[6] = _createTextVNode(" advanced sort ", -1)),
        (!_ctx.isActive && _ctx.modelValue.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "tw-animate-ping tw-absolute tw-inline-flex tw-h-full tw-w-full tw-rounded-full tw-bg-slate-400 tw-opacity-75" }, null, -1),
              _createElementVNode("span", { class: "tw-relative tw-inline-flex tw-rounded-full tw-h-2.5 tw-w-2.5 tw-bg-slate-900" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
              key: 1,
              icon: "circle-xmark",
              class: "tw-absolute tw-text-black tw-top-[-5px] tw-right-[-5px] tw-flex tw-h-2.5 tw-w-2.5"
            }))
          : _createCommentVNode("", true)
      ], 2),
      (!_ctx.isActive && _ctx.modelValue.length > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('activate'))),
            class: "tw-p-2 tw-text-slate-600 tw-bg-white/60 tw-border tw-border-slate-200 tw-rounded-xl tw-shadow-sm hover:tw-bg-white hover:tw-text-slate-900 tw-transition-all",
            title: "Restore advanced sort"
          }, [
            _createVNode(_component_font_awesome_icon, {
              icon: "rotate-left",
              class: "tw-text-xs"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortLevels, (level, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: level.id,
                class: "tw-flex tw-items-center tw-gap-2"
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(index === 0 ? 'sort by' : 'then by'), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((level.field) = $event),
                  class: "tw-flex-1 tw-text-xs tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg tw-px-2 tw-py-1.5 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-indigo-500"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFields, (field) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: field.value,
                      value: field.value,
                      disabled: _ctx.isFieldDisabled(field.value, level.id)
                    }, _toDisplayString(field.label), 9, _hoisted_8))
                  }), 128))
                ], 8, _hoisted_7), [
                  [_vModelSelect, level.field]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.toggleOrder(index)),
                  class: "tw-p-1.5 tw-bg-slate-50 tw-border tw-border-slate-200 tw-rounded-lg hover:tw-bg-slate-100",
                  title: "Toggle Order"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: level.order === 'ASC' ? 'sort-amount-up' : 'sort-amount-down',
                    class: "tw-text-slate-600 tw-w-3 tw-h-3"
                  }, null, 8, ["icon"])
                ], 8, _hoisted_9),
                (_ctx.sortLevels.length > 1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.removeLevel(index)),
                      class: "tw-text-slate-300 hover:tw-text-red-500 tw-transition-colors"
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "times" })
                    ], 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.sortLevels.length < _ctx.availableFields.length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addLevel && _ctx.addLevel(...args))),
                  class: "tw-text-left tw-text-xs tw-text-indigo-600 hover:tw-text-indigo-800 tw-font-medium tw-mt-1 tw-inline-flex tw-items-center tw-gap-1"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "plus",
                    class: "tw-text-[10px]"
                  }),
                  _cache[7] || (_cache[7] = _createTextVNode(" add sort level ", -1))
                ]))
              : _createCommentVNode("", true),
            _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "tw-border-slate-100 tw-my-1" }, null, -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetSort && _ctx.resetSort(...args))),
                class: "tw-text-xs tw-text-slate-500 hover:tw-text-slate-700"
              }, "Reset"),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applySort && _ctx.applySort(...args))),
                class: "tw-text-xs tw-bg-slate-900 tw-text-white tw-px-3 tw-py-1.5 tw-rounded-lg hover:tw-bg-slate-800"
              }, " Apply ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}